module.exports = __webpack_public_path__ + "static/media/3.a4a71182.jpeg";